/**
 * Returns if the given station name matches a search string.
 */
const stationMatches = (name, search) => {
  return name.toUpperCase().search(search.toUpperCase()) !== -1
}

export { stationMatches }
